import React, { useState, useEffect } from "react";
import { format, parse } from "date-fns";
import { datePickerIcon } from "../../../assetData/icons";
import { cn } from "../../../utils/twMerge";

import "./styles.css";

const CustomDateInput2 = ({
  initialValue,
  className,
  handleSetValue,
  handleValue,
  form1,
  value,
  className1,
  min,
  max,
  noMinMax,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(() => initialValue ?? null);
  const FinYear = sessionStorage.getItem("finYear");

  // Extract the start and end years from the FinYear
  const [startYear, endYear] = FinYear.split("-");

  // Get the current year and current date
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const formattedCurrentDate = format(currentDate, "yyyy-MM-dd");

  // Set the min and max dates
  const minDate = `${startYear}-04-01`;
  let maxDate = `20${endYear}-03-31`;

  // If the start year is the current year, set the max date to the current date
  if (parseInt(startYear, 10) === currentYear) {
    maxDate = formattedCurrentDate;
  }

  const formatDate = (rawDate) => {
    if (!rawDate) return;
    const parsedDate = parse(rawDate, "yyyy-MM-dd", new Date());
    const formattedDate = format(parsedDate, "dd MMM yyyy");
    return formattedDate;
  };

  const handleOnChange = (e) => {
    const date = e.target.value;
    setInputValue(formatDate(date));

    if (typeof handleSetValue === "function") {
      handleSetValue(date);
    }
  };

  useEffect(() => {
    if (!initialValue) setInputValue(null);
    setInputValue(() => {
      const formattedDate = formatDate(initialValue);
      return formattedDate;
    });
  }, [initialValue]);

  return (
    <div
      className={cn(
        "relative mt-1  flex  w-full justify-between gap-1  bg-[#f5f5f5] py-2",
        className,
      )}
    >
      <div className={` w-full text-[12px] text-[#636363] ${className1}`}>
        {inputValue ?? ""}
      </div>
      {/* <img src={datePickerIcon} className="w-5" alt="" /> */}
      <input
        {...props}
        {...form1}
        value={value}
        // min={noMinMax ? false : minDate}
        // max={noMinMax ? formattedCurrentDate : maxDate}
        min={min}
        max={max}
        type="date"
        onChange={handleOnChange}
        className="cus-date-input"
      />
    </div>
  );
};

export default CustomDateInput2;
